import {
  CatReaction,
  HeartReaction,
  QuestionReaction,
  ThumbsDownReaction,
  ThumbsUpReaction,
} from '@mentimeter/ragnar-visuals';

export const reactionIconsMap = {
  heart1: HeartReaction,
  cat: CatReaction,
  question: QuestionReaction,
  thumbsdown: ThumbsDownReaction,
  thumbsup: ThumbsUpReaction,
};
